import { useDispatch, useSelector } from 'react-redux';
import './css/app.css'
import './css/common.css'
import { useState, useEffect, useRef } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { MessageModal, LoadingModal } from './component/modal/modal';
import List from './component/list/list';
import { SearchSelect, SearchSelectText, SearchBtn } from './component/search/search';
import { useNavigate } from 'react-router-dom';
import { changeNum } from './common/function';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { X, Plus, BookOpen } from 'lucide-react';

dayjs.extend(utc);
dayjs.extend(timezone);

const STATUS_MAP = {
    'PENDING': '대기',
    'PARTIAL': '차감중',
    'COMPLETED': '완료',
    'CARRIED_OVER': '이월',
    'OFFLINE_COLLECTED': '수금완료',
};

const STATUS_COLOR = {
    'PENDING': { bg: '#fff3cd', color: '#856404' },
    'PARTIAL': { bg: '#cce5ff', color: '#004085' },
    'COMPLETED': { bg: '#d4edda', color: '#155724' },
    'CARRIED_OVER': { bg: '#f8d7da', color: '#721c24' },
    'OFFLINE_COLLECTED': { bg: '#e2e3e5', color: '#383d41' },
};

const safeNum = (v) => changeNum(Number(v) || 0);

const DEDUCTION_TYPE_MAP = {
    'PAYOUT': '정산차감',
    'OFFLINE': '직접수령',
};

const TRANSFER_STATUS_MAP = { 'Y': '완료', 'N': '대기', 'I': '처리중', 'F': '실패' };
const TRANSFER_STATUS_COLOR = { 'Y': '#155724', 'N': '#856404', 'I': '#004085', 'F': '#721c24' };

const STATUS_OPTIONS_MAP = {
    '전체': '',
    '대기': 'PENDING',
    '차감중': 'PARTIAL',
    '완료': 'COMPLETED',
    '이월': 'CARRIED_OVER',
    '수금완료': 'OFFLINE_COLLECTED',
};

function MerchantTerminalFee() {
    let dispatch = useDispatch();
    let navigate = useNavigate();
    const MyData = useSelector((state) => state.MyData);

    const [loading, setLoading] = useState(true);
    const [spinner, setSpinner] = useState(false);
    const [message, setMessage] = useState({ msg: "" });

    // 목록 관련
    const [page, setPage] = useState(1);
    const [maxFirstPage] = useState(30);
    const [listData, setListData] = useState({});
    const [listTrxData, setListTrxData] = useState([]);
    const [combineData, setCombineData] = useState([]);
    const [reload, setReload] = useState(false);

    // 필터
    const [feeMonth, setFeeMonth] = useState(dayjs().format('YYYY-MM'));
    const [statusFilter, setStatusFilter] = useState('전체'); // 한국어 라벨
    const [selectedValue, setSelectedValue] = useState("MID");
    const [selectedText, setSelectText] = useState("");

    // 모달
    const [detailModal, setDetailModal] = useState(false);
    const [detailData, setDetailData] = useState(null);
    const [merchantModal, setMerchantModal] = useState(false);
    const [merchantData, setMerchantData] = useState(null);

    // 수동부과 모달
    const [manualModal, setManualModal] = useState(false);
    const [manualMonth, setManualMonth] = useState(dayjs().format('YYYY-MM'));
    const [manualMemo, setManualMemo] = useState('');
    const [manualPreview, setManualPreview] = useState(null);
    const [manualChecked, setManualChecked] = useState([]);
    const [manualLoading, setManualLoading] = useState(false);

    // 오프라인 수금 모달
    const [offlineModal, setOfflineModal] = useState(false);
    const [offlineForm, setOfflineForm] = useState({ id: null, collected_by: '', memo: '' });

    // 메모 수정 모달
    const [memoModal, setMemoModal] = useState(false);
    const [memoForm, setMemoForm] = useState({ id: null, admin_memo: '' });

    // 가이드 모달
    const [guideModal, setGuideModal] = useState(false);

    useEffect(() => {
        dispatch(change_Current_Location("단말기비 관리"));
        dispatch(changeHeaderTitle({
            mainTitle: "관리자",
            subTitle: "단말기비 관리"
        }));
        setTimeout(() => setLoading(false), 500);
    }, []);

    // 목록 조회
    useEffect(() => {
        ListData();
    }, [page, maxFirstPage, reload]);

    const ListData = async () => {
        if (page === 1) setSpinner(true);
        try {
            const params = {
                page: page,
                limit: maxFirstPage,
            };
            if (feeMonth) params.fee_month = feeMonth;
            const statusValue = STATUS_OPTIONS_MAP[statusFilter] || '';
            if (statusValue) params.status = statusValue;
            if (selectedText) {
                if (selectedValue === "가맹점명") {
                    params.co_nm = selectedText;
                } else {
                    params.mid = selectedText;
                }
            }

            const response = await axios.get(process.env.REACT_APP_API + "/api/merchant-terminal-fee", {
                withCredentials: true,
                params: params,
            });
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setListData(tmp?.data ?? {});
                if (page === 1) {
                    setListTrxData(tmp?.data?.list ?? []);
                } else {
                    setListTrxData((prev) => [...prev, ...(tmp?.data?.list ?? [])]);
                }
            } else if (tmp?.code === 9999) {
                navigate('/');
            }
        } catch (error) {
            console.error(error);
            navigate('/');
        }
        setSpinner(false);
    };

    const onSubmitSearch = () => {
        setPage(1);
        setReload(e => !e);
    };

    // 테이블 헤더
    const tableHeaderData = [
        { "no": 0, "text": "부과월", "width": "80px", "textAlign": "center" },
        { "no": 1, "text": "MID", "width": "100px", "textAlign": "center" },
        { "no": 2, "text": "가맹점명", "width": "120px", "textAlign": "center" },
        { "no": 3, "text": "단말기수", "width": "60px", "textAlign": "center" },
        { "no": 4, "text": "단말기비", "width": "90px", "textAlign": "center" },
        { "no": 5, "text": "이월금액", "width": "90px", "textAlign": "center" },
        { "no": 6, "text": "총부과액", "width": "90px", "textAlign": "center" },
        { "no": 7, "text": "차감액", "width": "90px", "textAlign": "center" },
        { "no": 8, "text": "잔액", "width": "90px", "textAlign": "center" },
        { "no": 9, "text": "상태", "width": "80px", "textAlign": "center" },
        { "no": 10, "text": "부과일", "width": "100px", "textAlign": "center" },
        { "no": 11, "text": "메모", "width": "150px", "textAlign": "center" },
    ];

    // 테이블 바디
    useEffect(() => {
        let tableBodyData = [];
        if (listTrxData) {
            for (let i = 0; i < listTrxData.length; i++) {
                let data = listTrxData[i];
                let statusLabel = STATUS_MAP[data.status] || data.status;
                let statusStyle = STATUS_COLOR[data.status] || {};
                if (data.status === 'COMPLETED') {
                    if (data.pending_transfer_count > 0) {
                        statusLabel = '부여 완료';
                        statusStyle = { bg: '#fff3cd', color: '#856404' };
                    } else {
                        statusLabel = '이체 완료';
                    }
                }

                tableBodyData.push([
                    { "no": 0, "text": data.fee_month, "width": "80px", "textAlign": "center" },
                    { "no": 1, "text": data.mid, "width": "100px", "textAlign": "center" },
                    { "no": 2, "text": data.co_nm ?? "-", "width": "120px", "textAlign": "left" },
                    { "no": 3, "text": String(data.terminal_count ?? 0), "width": "60px", "textAlign": "center" },
                    { "no": 4, "text": safeNum(data.total_fee), "width": "90px", "textAlign": "right" },
                    { "no": 5, "text": safeNum(data.carried_over_amount), "width": "90px", "textAlign": "right" },
                    { "no": 6, "text": safeNum(data.total_due), "width": "90px", "textAlign": "right" },
                    { "no": 7, "text": safeNum(data.deducted_amount), "width": "90px", "textAlign": "right" },
                    {
                        "no": 8,
                        "text": safeNum(data.remaining_amount),
                        "width": "90px",
                        "textAlign": "right",
                        "style": { color: Number(data.remaining_amount) > 0 ? "#dc3545" : "#155724", fontWeight: "600" }
                    },
                    {
                        "no": 9,
                        "text": (
                            <span style={{
                                padding: "2px 8px",
                                borderRadius: "4px",
                                fontSize: "11px",
                                fontWeight: "600",
                                backgroundColor: data.terminal_fee_yn === "N" ? "#f8d7da" : statusStyle.bg,
                                color: data.terminal_fee_yn === "N" ? "#721c24" : statusStyle.color,
                            }}>
                                {data.terminal_fee_yn === "N" ? "부과중지" : statusLabel}
                            </span>
                        ),
                        "width": "80px",
                        "textAlign": "center"
                    },
                    { "no": 10, "text": data.last_deducted_at ? dayjs.utc(data.last_deducted_at).tz('Asia/Seoul').format('YYYY-MM-DD') : "-", "width": "100px", "textAlign": "center" },
                    { "no": 11, "text": data.admin_memo ?? "", "width": "150px", "textAlign": "left" },
                ]);
                // rowArr에 id 저장
                tableBodyData[tableBodyData.length - 1].id = data.id;
                tableBodyData[tableBodyData.length - 1].mid = data.mid;
                tableBodyData[tableBodyData.length - 1]._raw = data;
            }
            setCombineData(tableBodyData);
        }
    }, [listTrxData]);

    // 무한스크롤
    const observerRef = useRef(null);
    useEffect(() => {
        if (combineData.length === 0) return;
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && (listData.totCnt ?? 0) >= page * maxFirstPage) {
                setPage((prev) => prev + 1);
            }
        });
        if (observerRef.current) observer.observe(observerRef.current);
        return () => {
            if (observerRef.current) observer.unobserve(observerRef.current);
        };
    }, [combineData]);

    // 행 클릭 => 상세 조회
    const [clickData, setClickData] = useState(null);
    const onRowClick = (rowArr) => {
        const raw = rowArr._raw;
        if (!raw) return;
        setClickData(rowArr);
        fetchDetail(raw.id);
    };

    const fetchDetail = async (id) => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + `/api/merchant-terminal-fee/${id}`, {
                withCredentials: true,
            });
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setDetailData({ ...tmp?.data?.fee, deductionLogs: tmp?.data?.deductionLogs ?? [] });
                setDetailModal(true);
            } else if (tmp?.code === 9999) {
                navigate('/');
            }
        } catch (error) {
            console.error(error);
        }
    };

    // 가맹점별 이력 조회
    const fetchMerchantHistory = async (mid) => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + `/api/merchant-terminal-fee/merchant/${mid}`, {
                withCredentials: true,
            });
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setMerchantData(tmp?.data);
                setMerchantModal(true);
            } else if (tmp?.code === 9999) {
                navigate('/');
            }
        } catch (error) {
            console.error(error);
        }
    };

    // 오프라인 수금
    const handleOfflineCollect = async () => {
        if (!offlineForm.collected_by) {
            setMessage({ msg: "수금자명을 입력해주세요." });
            return;
        }
        try {
            const response = await axios.put(
                process.env.REACT_APP_API + `/api/merchant-terminal-fee/${offlineForm.id}/offline-collect`,
                { collected_by: offlineForm.collected_by, memo: offlineForm.memo },
                { withCredentials: true }
            );
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setMessage({ msg: "오프라인 수금 처리가 완료되었습니다." });
                setOfflineModal(false);
                setDetailModal(false);
                setReload(e => !e);
            } else {
                setMessage({ msg: tmp?.msg ?? "처리에 실패했습니다." });
            }
        } catch (error) {
            setMessage({ msg: "오류가 발생했습니다." });
        }
    };

    // 메모 수정
    const handleMemoUpdate = async () => {
        try {
            const response = await axios.put(
                process.env.REACT_APP_API + `/api/merchant-terminal-fee/${memoForm.id}/memo`,
                { admin_memo: memoForm.admin_memo },
                { withCredentials: true }
            );
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setMessage({ msg: "메모가 수정되었습니다." });
                setMemoModal(false);
                if (detailData) fetchDetail(memoForm.id);
                setReload(e => !e);
            } else {
                setMessage({ msg: tmp?.msg ?? "수정에 실패했습니다." });
            }
        } catch (error) {
            setMessage({ msg: "오류가 발생했습니다." });
        }
    };

    // 부과 취소
    const handleCancel = async (id) => {
        if (!window.confirm("해당 부과 건을 취소하시겠습니까?")) return;
        try {
            const response = await axios.delete(
                process.env.REACT_APP_API + `/api/merchant-terminal-fee/${id}/cancel`,
                { withCredentials: true }
            );
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setMessage({ msg: "부과 취소가 완료되었습니다." });
                setDetailModal(false);
                setReload(e => !e);
            } else {
                setMessage({ msg: tmp?.msg ?? "취소에 실패했습니다." });
            }
        } catch (error) {
            setMessage({ msg: "오류가 발생했습니다." });
        }
    };

    // 수동부과 미리보기
    const fetchManualPreview = async (month) => {
        setManualLoading(true);
        setManualPreview(null);
        setManualChecked([]);
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + "/api/merchant-terminal-fee/manual-preview",
                { withCredentials: true, params: { fee_month: month } }
            );
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setManualPreview(tmp?.data);
                setManualChecked((tmp?.data?.list ?? []).map(item => item.mid));
            } else {
                setMessage({ msg: tmp?.msg ?? "미리보기 조회에 실패했습니다." });
            }
        } catch (error) {
            setMessage({ msg: "오류가 발생했습니다." });
        }
        setManualLoading(false);
    };

    // 수동부과 실행
    const handleManualCharge = async () => {
        if (manualChecked.length === 0) {
            setMessage({ msg: "부과할 가맹점을 선택해주세요." });
            return;
        }
        if (!window.confirm(`${manualChecked.length}건을 부과하시겠습니까?`)) return;
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/merchant-terminal-fee/manual",
                { fee_month: manualMonth, mids: manualChecked, memo: manualMemo },
                { withCredentials: true }
            );
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                const results = tmp?.data?.results ?? [];
                setMessage({ msg: `${results.length}건 부과 완료` });
                setManualModal(false);
                setManualPreview(null);
                setManualMemo('');
                setReload(e => !e);
            } else {
                setMessage({ msg: tmp?.msg ?? "부과에 실패했습니다." });
            }
        } catch (error) {
            setMessage({ msg: "오류가 발생했습니다." });
        }
    };

    // 당월 버튼
    const handleThisMonth = () => {
        const m = dayjs().format('YYYY-MM');
        setFeeMonth(m);
        onSubmitSearch();
    };

    // 전월 버튼 (선택된 월 기준 -1)
    const handlePrevMonth = () => {
        const m = dayjs(feeMonth + '-01').subtract(1, 'month').format('YYYY-MM');
        setFeeMonth(m);
        onSubmitSearch();
    };

    return (
        <div className="content" id="contents" style={{ display: "flex", flexDirection: "column" }}>
            {loading ? <LoadingModal /> : ""}
            <MessageModal message={message} setMessage={setMessage} />

            {/* 필터 + 요약 통합 영역 (고정) */}
            <div className="intro-y box" style={{ padding: "14px 20px", marginBottom: "12px", flexShrink: 0 }}>
                <form id="tabulator-html-filter-form" style={{ display: "flex", flexWrap: "wrap", gap: "8px", alignItems: "center" }}>
                    <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                        <input
                            type="month"
                            className="form-control"
                            style={{ height: "30px", fontSize: "12px", width: "150px" }}
                            value={feeMonth}
                            onChange={(e) => {
                                setFeeMonth(e.target.value);
                                onSubmitSearch();
                            }}
                        />
                        <button type="button" className="btn searchPayBtn" style={{ height: "30px", fontSize: "12px" }} onClick={handleThisMonth}>당월</button>
                        <button type="button" className="btn searchPayBtn" style={{ height: "30px", fontSize: "12px" }} onClick={handlePrevMonth}>전월</button>
                    </div>

                    <SearchSelect
                        selectData={Object.keys(STATUS_OPTIONS_MAP)}
                        handleSelectChange={(e) => { setStatusFilter(e.target.value); }}
                        selectedValue={statusFilter}
                    />

                    <SearchSelectText
                        selectData={["MID", "가맹점명"]}
                        handleSelectChange={(e) => setSelectedValue(e.target.value)}
                        selectedValue={selectedValue}
                        handleSelectTextChange={(e) => setSelectText(e.target.value)}
                        selectedText={selectedText}
                        onClick={() => onSubmitSearch()}
                        btnText={"검색"}
                        placeholder={"MID 또는 가맹점명"}
                    />

                    <div style={{ display: "flex", gap: "6px", marginLeft: "auto" }}>
                        <button
                            type="button"
                            className="btn btn-primary modal_btn btn_small"
                            onClick={() => { setManualMonth(feeMonth); setManualModal(true); setManualPreview(null); setManualMemo(''); }}
                            style={{ height: "30px", fontSize: "12px" }}
                        >
                            <Plus size={14} style={{ marginRight: "4px" }} />
                            수동부과
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-secondary btn_small"
                            onClick={() => setGuideModal(true)}
                            style={{ height: "30px", fontSize: "12px", display: "flex", alignItems: "center", gap: "4px" }}
                        >
                            <BookOpen size={14} />
                            가이드
                        </button>
                    </div>
                </form>

                {/* 요약 바 */}
                {listData?.summary && (
                    <div style={{ display: "flex", gap: "16px", flexWrap: "wrap", marginTop: "12px", paddingTop: "10px", borderTop: "1px solid #e5e7eb", fontSize: "12px" }}>
                        <SummaryItem label="부과" value={`${listData.summary.total_count}건`} />
                        <SummaryItem label="부과액" value={`${safeNum(listData.summary.total_due_sum)}원`} />
                        <SummaryItem label="차감" value={`${safeNum(listData.summary.deducted_sum)}원`} color="#004085" />
                        <SummaryItem label="잔액" value={`${safeNum(listData.summary.remaining_sum)}원`} color="#dc3545" />
                        <span style={{ color: "#d1d5db" }}>|</span>
                        <SummaryItem label="이체 완료" value={listData.summary.completed_transferred_count ?? listData.summary.completed_count} color="#155724" />
                        <SummaryItem label="부여 완료" value={listData.summary.completed_pending_count ?? 0} color="#856404" />
                        <SummaryItem label="대기" value={listData.summary.pending_count} color="#856404" />
                        <SummaryItem label="수금" value={listData.summary.offline_count} color="#383d41" />
                    </div>
                )}
            </div>

            {/* 목록 (남은 공간 채움) */}
            <div className="intro-y box intro-padding">
                <div style={{ width: "100%" }}>
                    <List
                        tableHeaderData={tableHeaderData}
                        tableBodyData={listData?.totCnt ?? 0}
                        filter_tableBodyData={combineData}
                        page={page}
                        setPage={setPage}
                        maxFirstPage={maxFirstPage}
                        observerRef={observerRef}
                        nonePage={false}
                        scrollState={true}
                        spinner={spinner}
                        height={"calc(100vh - 320px)"}
                        clickData={clickData}
                        onRowClick={onRowClick}
                    />
                </div>
            </div>

            {/* 상세 모달 */}
            {detailModal && detailData && (
                <ModalOverlay onClose={() => setDetailModal(false)}>
                    <div style={{ width: "560px", maxHeight: "80vh", overflow: "auto" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                            <h3 style={{ fontSize: "16px", fontWeight: "700", margin: 0 }}>단말기비 상세</h3>
                            <button onClick={() => setDetailModal(false)} style={closeBtnStyle}><X size={18} /></button>
                        </div>

                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px", fontSize: "13px", marginBottom: "16px" }}>
                            <InfoRow label="부과월" value={detailData.fee_month} />
                            <InfoRow label="MID" value={detailData.mid} />
                            <InfoRow label="가맹점명" value={detailData.co_nm} />
                            <InfoRow label="단말기수" value={detailData.terminal_count} />
                            <InfoRow label="단말기비" value={safeNum(detailData.total_fee) + "원"} />
                            <InfoRow label="이월금액" value={safeNum(detailData.carried_over_amount) + "원"} />
                            <InfoRow label="총부과액" value={safeNum(detailData.total_due) + "원"} />
                            <InfoRow label="차감액" value={safeNum(detailData.deducted_amount) + "원"} />
                            <InfoRow label="잔액" value={safeNum(detailData.remaining_amount) + "원"} bold color={Number(detailData.remaining_amount) > 0 ? "#dc3545" : "#155724"} />
                            <InfoRow label="상태" value={(() => {
                                let label = STATUS_MAP[detailData.status] || detailData.status;
                                let style = STATUS_COLOR[detailData.status] || {};
                                if (detailData.status === 'COMPLETED') {
                                    if (detailData.pending_transfer_count > 0) {
                                        label = '부여 완료';
                                        style = { bg: '#fff3cd', color: '#856404' };
                                    } else {
                                        label = '이체 완료';
                                    }
                                }
                                return (
                                    <span style={{ padding: "2px 8px", borderRadius: "4px", fontSize: "11px", fontWeight: "600", backgroundColor: style.bg, color: style.color }}>
                                        {label}
                                    </span>
                                );
                            })()} />
                            {detailData.admin_memo && <InfoRow label="메모" value={detailData.admin_memo} span2 />}
                        </div>

                        {/* 차감 이력 */}
                        {detailData.deductionLogs && detailData.deductionLogs.length > 0 && (
                            <div style={{ marginBottom: "16px" }}>
                                <h4 style={{ fontSize: "13px", fontWeight: "700", marginBottom: "8px" }}>차감 이력</h4>
                                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
                                    <thead>
                                        <tr style={{ backgroundColor: "#f8f9fa", borderBottom: "2px solid #dee2e6" }}>
                                            <th style={thStyle}>유형</th>
                                            <th style={thStyle}>정산ID</th>
                                            <th style={thStyle}>차감액</th>
                                            <th style={thStyle}>잔액</th>
                                            <th style={thStyle}>이체</th>
                                            <th style={thStyle}>일시</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {detailData.deductionLogs.map((log, idx) => (
                                            <tr key={idx} style={{ borderBottom: "1px solid #dee2e6" }}>
                                                <td style={tdStyle}>{DEDUCTION_TYPE_MAP[log.deduction_type] || log.deduction_type}</td>
                                                <td style={tdStyle}>{log.payout_id ?? "-"}</td>
                                                <td style={{ ...tdStyle, textAlign: "right" }}>{safeNum(log.deduction_amount)}</td>
                                                <td style={{ ...tdStyle, textAlign: "right" }}>{safeNum(log.remaining_after)}</td>
                                                <td style={tdStyle}>
                                                    {log.payout_transfer_status ? (
                                                        <span style={{ color: TRANSFER_STATUS_COLOR[log.payout_transfer_status] || '#333', fontWeight: "600" }}>
                                                            {TRANSFER_STATUS_MAP[log.payout_transfer_status] || log.payout_transfer_status}
                                                        </span>
                                                    ) : "-"}
                                                </td>
                                                <td style={tdStyle}>{log.created_at}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {/* 액션 버튼 */}
                        <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
                            {detailData.status === 'PENDING' && (
                                <button
                                    className="btn"
                                    style={{ height: "32px", fontSize: "12px", color: "#dc3545", border: "1px solid #dc3545" }}
                                    onClick={() => handleCancel(detailData.id)}
                                >
                                    부과취소
                                </button>
                            )}
                            <button
                                className="btn searchPayBtn"
                                style={{ height: "32px", fontSize: "12px" }}
                                onClick={() => fetchMerchantHistory(detailData.mid)}
                            >
                                가맹점 이력
                            </button>
                            <button
                                className="btn searchPayBtn"
                                style={{ height: "32px", fontSize: "12px" }}
                                onClick={() => {
                                    setMemoForm({ id: detailData.id, admin_memo: detailData.admin_memo || '' });
                                    setMemoModal(true);
                                }}
                            >
                                메모수정
                            </button>
                            {detailData.status !== 'COMPLETED' && detailData.status !== 'OFFLINE_COLLECTED' && (
                                <button
                                    className="btn btn-primary"
                                    style={{ height: "32px", fontSize: "12px" }}
                                    onClick={() => {
                                        setOfflineForm({ id: detailData.id, collected_by: '', memo: '' });
                                        setOfflineModal(true);
                                    }}
                                >
                                    오프라인 수금
                                </button>
                            )}
                        </div>
                    </div>
                </ModalOverlay>
            )}

            {/* 가맹점 이력 모달 */}
            {merchantModal && merchantData && (
                <ModalOverlay onClose={() => setMerchantModal(false)}>
                    <div style={{ width: "600px", maxHeight: "80vh", overflow: "auto" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                            <h3 style={{ fontSize: "16px", fontWeight: "700", margin: 0 }}>
                                가맹점 이력 - {merchantData.merchant?.co_nm} ({merchantData.merchant?.mid})
                            </h3>
                            <button onClick={() => setMerchantModal(false)} style={closeBtnStyle}><X size={18} /></button>
                        </div>

                        {/* 가맹점 요약 */}
                        <div style={{ display: "flex", gap: "16px", fontSize: "12px", marginBottom: "16px", padding: "8px 0", borderBottom: "1px solid #e5e7eb" }}>
                            <SummaryItem label="총 부과액" value={safeNum(merchantData.summary?.totalDue) + "원"} />
                            <SummaryItem label="총 차감액" value={safeNum(merchantData.summary?.totalDeducted) + "원"} color="#004085" />
                            <SummaryItem label="총 잔액" value={safeNum(merchantData.summary?.totalRemaining) + "원"} color="#dc3545" />
                        </div>

                        {/* 월별 단말기비 */}
                        <h4 style={{ fontSize: "13px", fontWeight: "700", marginBottom: "8px" }}>월별 단말기비</h4>
                        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px", marginBottom: "16px" }}>
                            <thead>
                                <tr style={{ backgroundColor: "#f8f9fa", borderBottom: "2px solid #dee2e6" }}>
                                    <th style={thStyle}>부과월</th>
                                    <th style={thStyle}>단말기수</th>
                                    <th style={thStyle}>총부과액</th>
                                    <th style={thStyle}>차감액</th>
                                    <th style={thStyle}>잔액</th>
                                    <th style={thStyle}>상태</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(merchantData.fees ?? []).map((fee, idx) => {
                                    const sColor = STATUS_COLOR[fee.status] || {};
                                    return (
                                        <tr key={idx} style={{ borderBottom: "1px solid #dee2e6" }}>
                                            <td style={tdStyle}>{fee.fee_month}</td>
                                            <td style={tdStyle}>{fee.terminal_count ?? "-"}</td>
                                            <td style={{ ...tdStyle, textAlign: "right" }}>{safeNum(fee.total_due)}</td>
                                            <td style={{ ...tdStyle, textAlign: "right" }}>{safeNum(fee.deducted_amount)}</td>
                                            <td style={{ ...tdStyle, textAlign: "right" }}>{safeNum(fee.remaining_amount)}</td>
                                            <td style={tdStyle}>
                                                <span style={{
                                                    padding: "2px 8px", borderRadius: "4px", fontSize: "11px", fontWeight: "600",
                                                    backgroundColor: sColor.bg, color: sColor.color,
                                                }}>
                                                    {STATUS_MAP[fee.status] || fee.status}
                                                </span>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>

                        {/* 차감 로그 */}
                        {merchantData.deductionLogs && merchantData.deductionLogs.length > 0 && (
                            <>
                                <h4 style={{ fontSize: "13px", fontWeight: "700", marginBottom: "8px" }}>차감 로그</h4>
                                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
                                    <thead>
                                        <tr style={{ backgroundColor: "#f8f9fa", borderBottom: "2px solid #dee2e6" }}>
                                            <th style={thStyle}>유형</th>
                                            <th style={thStyle}>정산ID</th>
                                            <th style={thStyle}>차감액</th>
                                            <th style={thStyle}>잔액</th>
                                            <th style={thStyle}>이체</th>
                                            <th style={thStyle}>일시</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {merchantData.deductionLogs.map((log, idx) => (
                                            <tr key={idx} style={{ borderBottom: "1px solid #dee2e6" }}>
                                                <td style={tdStyle}>{DEDUCTION_TYPE_MAP[log.deduction_type] || log.deduction_type}</td>
                                                <td style={tdStyle}>{log.payout_id ?? "-"}</td>
                                                <td style={{ ...tdStyle, textAlign: "right" }}>{safeNum(log.deduction_amount)}</td>
                                                <td style={{ ...tdStyle, textAlign: "right" }}>{safeNum(log.remaining_after)}</td>
                                                <td style={tdStyle}>
                                                    {log.payout_transfer_status ? (
                                                        <span style={{ color: TRANSFER_STATUS_COLOR[log.payout_transfer_status] || '#333', fontWeight: "600" }}>
                                                            {TRANSFER_STATUS_MAP[log.payout_transfer_status] || log.payout_transfer_status}
                                                        </span>
                                                    ) : "-"}
                                                </td>
                                                <td style={tdStyle}>{log.created_at}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </>
                        )}
                    </div>
                </ModalOverlay>
            )}

            {/* 수동 부과 모달 */}
            {manualModal && (
                <ModalOverlay onClose={() => setManualModal(false)}>
                    <div style={{ width: "600px", maxHeight: "80vh", display: "flex", flexDirection: "column" }}>
                        {/* 헤더 (고정) */}
                        <div style={{ flexShrink: 0 }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                                <h3 style={{ fontSize: "16px", fontWeight: "700", margin: 0 }}>수동 부과</h3>
                                <button onClick={() => setManualModal(false)} style={closeBtnStyle}><X size={18} /></button>
                            </div>

                            <div style={{ display: "flex", gap: "8px", alignItems: "center", marginBottom: "16px" }}>
                                <FormField label="부과월">
                                    <input
                                        type="month"
                                        className="form-control"
                                        style={{ height: "32px", fontSize: "13px", width: "160px" }}
                                        value={manualMonth}
                                        onChange={(e) => setManualMonth(e.target.value)}
                                    />
                                </FormField>
                                <button
                                    className="btn btn-primary"
                                    style={{ height: "32px", fontSize: "12px", marginTop: "18px" }}
                                    onClick={() => fetchManualPreview(manualMonth)}
                                >
                                    미리보기
                                </button>
                            </div>
                        </div>

                        {/* 미리보기 결과 */}
                        {manualLoading && <div style={{ textAlign: "center", padding: "20px", color: "#6b7280", fontSize: "13px" }}>조회 중...</div>}

                        {manualPreview && !manualLoading && (
                            <>
                                {manualPreview.list.length === 0 ? (
                                    <div style={{ textAlign: "center", padding: "20px", color: "#999", fontSize: "13px" }}>추가 부과 대상이 없습니다.</div>
                                ) : (
                                    <>
                                        {/* 요약 (고정) */}
                                        <div style={{ display: "flex", gap: "16px", fontSize: "12px", marginBottom: "12px", flexShrink: 0 }}>
                                            <SummaryItem label="대상" value={`${manualPreview.target_count}건`} />
                                            <SummaryItem label="전체 부과액" value={`${safeNum(manualPreview.total_add_fee)}원`} />
                                            <span style={{ color: "#d1d5db" }}>|</span>
                                            <SummaryItem label="선택" value={`${manualChecked.length}건`} color="#155724" />
                                            <SummaryItem label="선택 부과액" value={`${safeNum(manualPreview.list.filter(i => manualChecked.includes(i.mid)).reduce((s, i) => s + (Number(i.add_fee) || 0), 0))}원`} color="#004085" />
                                        </div>

                                        {/* 테이블 (스크롤) */}
                                        <div style={{ flex: 1, minHeight: 0, overflow: "auto", marginBottom: "12px" }}>
                                            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
                                                <thead style={{ position: "sticky", top: 0, zIndex: 1 }}>
                                                    <tr style={{ backgroundColor: "#f8f9fa", borderBottom: "2px solid #dee2e6" }}>
                                                        <th style={{ ...thStyle, width: "36px" }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={manualChecked.length === manualPreview.list.length}
                                                                onChange={(e) => {
                                                                    if (e.target.checked) {
                                                                        setManualChecked(manualPreview.list.map(item => item.mid));
                                                                    } else {
                                                                        setManualChecked([]);
                                                                    }
                                                                }}
                                                            />
                                                        </th>
                                                        <th style={thStyle}>MID</th>
                                                        <th style={thStyle}>유형</th>
                                                        <th style={thStyle}>현재</th>
                                                        <th style={thStyle}>부과됨</th>
                                                        <th style={thStyle}>추가</th>
                                                        <th style={thStyle}>추가금액</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {manualPreview.list.map((item, idx) => (
                                                        <tr key={idx} style={{ borderBottom: "1px solid #dee2e6" }}>
                                                            <td style={tdStyle}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={manualChecked.includes(item.mid)}
                                                                    onChange={(e) => {
                                                                        if (e.target.checked) {
                                                                            setManualChecked(prev => [...prev, item.mid]);
                                                                        } else {
                                                                            setManualChecked(prev => prev.filter(m => m !== item.mid));
                                                                        }
                                                                    }}
                                                                />
                                                            </td>
                                                            <td style={tdStyle}>{item.mid}</td>
                                                            <td style={tdStyle}>
                                                                <span style={{
                                                                    padding: "2px 6px", borderRadius: "4px", fontSize: "11px", fontWeight: "600",
                                                                    backgroundColor: item.type === 'NEW' ? '#d4edda' : '#cce5ff',
                                                                    color: item.type === 'NEW' ? '#155724' : '#004085',
                                                                }}>
                                                                    {item.type === 'NEW' ? '신규' : '추가'}
                                                                </span>
                                                            </td>
                                                            <td style={tdStyle}>{item.current_terminals}</td>
                                                            <td style={tdStyle}>{item.charged_terminals}</td>
                                                            <td style={{ ...tdStyle, fontWeight: "600" }}>{item.add_terminals}</td>
                                                            <td style={{ ...tdStyle, textAlign: "right" }}>{safeNum(item.add_fee)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* 하단 (고정) */}
                                        <div style={{ flexShrink: 0, borderTop: "1px solid #e5e7eb", paddingTop: "12px" }}>
                                            <FormField label="메모">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    style={{ height: "32px", fontSize: "13px" }}
                                                    value={manualMemo}
                                                    onChange={(e) => setManualMemo(e.target.value)}
                                                    placeholder="메모 (선택)"
                                                />
                                            </FormField>

                                            <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "12px" }}>
                                                <button className="btn searchPayBtn" style={{ height: "32px", fontSize: "12px" }} onClick={() => setManualModal(false)}>취소</button>
                                                <button className="btn btn-primary" style={{ height: "32px", fontSize: "12px" }} onClick={handleManualCharge}>
                                                    {manualChecked.length}건 부과
                                                </button>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </>
                        )}
                    </div>
                </ModalOverlay>
            )}

            {/* 오프라인 수금 모달 */}
            {offlineModal && (
                <ModalOverlay onClose={() => setOfflineModal(false)}>
                    <div style={{ width: "400px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                            <h3 style={{ fontSize: "16px", fontWeight: "700", margin: 0 }}>오프라인 수금 처리</h3>
                            <button onClick={() => setOfflineModal(false)} style={closeBtnStyle}><X size={18} /></button>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                            <FormField label="수금자명">
                                <input
                                    type="text"
                                    className="form-control"
                                    style={{ height: "32px", fontSize: "13px" }}
                                    value={offlineForm.collected_by}
                                    onChange={(e) => setOfflineForm({ ...offlineForm, collected_by: e.target.value })}
                                    placeholder="수금자명"
                                />
                            </FormField>
                            <FormField label="메모">
                                <input
                                    type="text"
                                    className="form-control"
                                    style={{ height: "32px", fontSize: "13px" }}
                                    value={offlineForm.memo}
                                    onChange={(e) => setOfflineForm({ ...offlineForm, memo: e.target.value })}
                                    placeholder="메모 (선택)"
                                />
                            </FormField>
                            <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "8px" }}>
                                <button className="btn searchPayBtn" style={{ height: "32px", fontSize: "12px" }} onClick={() => setOfflineModal(false)}>취소</button>
                                <button className="btn btn-primary" style={{ height: "32px", fontSize: "12px" }} onClick={handleOfflineCollect}>수금처리</button>
                            </div>
                        </div>
                    </div>
                </ModalOverlay>
            )}

            {/* 메모 수정 모달 */}
            {memoModal && (
                <ModalOverlay onClose={() => setMemoModal(false)}>
                    <div style={{ width: "400px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                            <h3 style={{ fontSize: "16px", fontWeight: "700", margin: 0 }}>메모 수정</h3>
                            <button onClick={() => setMemoModal(false)} style={closeBtnStyle}><X size={18} /></button>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                            <FormField label="메모">
                                <textarea
                                    className="form-control"
                                    style={{ fontSize: "13px", minHeight: "80px", resize: "vertical" }}
                                    value={memoForm.admin_memo}
                                    onChange={(e) => setMemoForm({ ...memoForm, admin_memo: e.target.value })}
                                    placeholder="관리자 메모"
                                />
                            </FormField>
                            <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "8px" }}>
                                <button className="btn searchPayBtn" style={{ height: "32px", fontSize: "12px" }} onClick={() => setMemoModal(false)}>취소</button>
                                <button className="btn btn-primary" style={{ height: "32px", fontSize: "12px" }} onClick={handleMemoUpdate}>저장</button>
                            </div>
                        </div>
                    </div>
                </ModalOverlay>
            )}

            {/* 가이드 모달 */}
            {guideModal && (
                <TerminalFeeGuideModal onClose={() => setGuideModal(false)} />
            )}
        </div>
    );
}

// 단말기비 가이드 모달
function TerminalFeeGuideModal({ onClose }) {
    const gCardStyle = {
        backgroundColor: '#fff', borderRadius: '10px', padding: '20px 24px',
        marginBottom: '16px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', border: '1px solid #eee',
    };
    const gTitleStyle = {
        fontSize: '16px', fontWeight: 700, color: '#1e293b', marginBottom: '12px',
        paddingBottom: '8px', borderBottom: '2px solid #e2e8f0',
    };
    const gP = { fontSize: '13px', lineHeight: '1.8', color: '#334155', margin: '0 0 8px 0' };
    const gList = { fontSize: '13px', lineHeight: '2', color: '#334155', margin: '0 0 8px 0', paddingLeft: '20px' };
    const gHighlight = {
        backgroundColor: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: '8px',
        padding: '12px 16px', margin: '10px 0', fontSize: '13px', lineHeight: '1.7', color: '#0c4a6e',
    };
    const gWarning = {
        backgroundColor: '#fef3c7', border: '1px solid #fcd34d', borderRadius: '8px',
        padding: '12px 16px', margin: '10px 0', fontSize: '13px', lineHeight: '1.7', color: '#92400e',
    };
    const gTh = { backgroundColor: '#f8fafc', padding: '8px 12px', textAlign: 'left', fontWeight: 600, color: '#475569', borderBottom: '2px solid #e2e8f0', fontSize: '12px' };
    const gTd = { padding: '8px 12px', borderBottom: '1px solid #f1f5f9', color: '#334155', fontSize: '12px' };
    const gTable = { width: '100%', borderCollapse: 'collapse', margin: '10px 0' };

    const Badge = ({ status }) => {
        const s = STATUS_COLOR[status];
        if (!s) return null;
        return (
            <span style={{
                display: 'inline-block', padding: '1px 8px', borderRadius: '10px',
                fontSize: '12px', fontWeight: 600, backgroundColor: s.bg, color: s.color, marginRight: '4px',
            }}>{STATUS_MAP[status]}</span>
        );
    };

    const FlowNode = ({ label, status }) => {
        const s = STATUS_COLOR[status] || { bg: '#f1f5f9', color: '#475569' };
        return (
            <span style={{
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                padding: '5px 14px', borderRadius: '6px', fontSize: '12px', fontWeight: 600,
                backgroundColor: s.bg, color: s.color, border: `1px solid ${s.color}30`,
            }}>{label}</span>
        );
    };

    const sections = [
        { id: 'g-overview', label: '개요' },
        { id: 'g-charge', label: '자동 부과' },
        { id: 'g-deduct', label: '자동 차감' },
        { id: 'g-carryover', label: '이월' },
        { id: 'g-status', label: '상태 설명' },
        { id: 'g-manual', label: '수동 부과' },
        { id: 'g-cancel', label: '부과 취소' },
        { id: 'g-offline', label: '직접 수금' },
        { id: 'g-restore', label: '이체 취소 시 복원' },
        { id: 'g-flow', label: '상태 흐름도' },
        { id: 'g-faq', label: 'FAQ' },
    ];

    const scrollTo = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    return (
        <div
            style={{
                position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999,
                display: "flex", alignItems: "center", justifyContent: "center",
            }}
            onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
        >
            <div style={{
                backgroundColor: "#f8fafc", borderRadius: "12px", width: "900px", maxWidth: "95vw",
                height: "85vh", display: "flex", flexDirection: "column",
                boxShadow: "0 8px 40px rgba(0,0,0,0.2)",
            }}>
                {/* 헤더 */}
                <div style={{
                    display: "flex", justifyContent: "space-between", alignItems: "center",
                    padding: "16px 24px", borderBottom: "1px solid #e2e8f0", backgroundColor: "#fff",
                    borderRadius: "12px 12px 0 0", flexShrink: 0,
                }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <BookOpen size={20} style={{ color: "#2563eb" }} />
                        <span style={{ fontSize: "16px", fontWeight: 700, color: "#1e293b" }}>단말기비 운영 가이드</span>
                    </div>
                    <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", padding: "4px", display: "flex" }}>
                        <X size={20} color="#64748b" />
                    </button>
                </div>

                {/* 본문 */}
                <div style={{ display: "flex", flex: 1, overflow: "hidden" }}>
                    {/* 목차 */}
                    <div style={{
                        width: '180px', minWidth: '180px', backgroundColor: '#fff',
                        borderRight: '1px solid #e2e8f0', padding: '12px 0', overflowY: 'auto',
                    }}>
                        {sections.map((sec) => (
                            <div
                                key={sec.id}
                                onClick={() => scrollTo(sec.id)}
                                style={{
                                    padding: '7px 14px', cursor: 'pointer', fontSize: '12px',
                                    color: '#64748b', fontWeight: 400,
                                    transition: 'all 0.15s',
                                }}
                                onMouseEnter={(e) => { e.target.style.backgroundColor = '#eff6ff'; e.target.style.color = '#2563eb'; }}
                                onMouseLeave={(e) => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = '#64748b'; }}
                            >
                                {sec.label}
                            </div>
                        ))}
                    </div>

                    {/* 콘텐츠 */}
                    <div style={{ flex: 1, overflowY: 'auto', padding: '20px 24px' }}>

                        {/* 1. 개요 */}
                        <div id="g-overview" style={gCardStyle}>
                            <div style={gTitleStyle}>1. 개요</div>
                            <p style={gP}>
                                가맹점이 사용 중인 <b>활성 단말기(POS)</b>에 대해 <b>월 11,000원/대</b>의 단말기비가 부과됩니다.
                                부과된 금액은 매일 정산금에서 자동 차감되며, 월말까지 완납되지 않으면 다음 달로 이월됩니다.
                            </p>
                            <div style={gHighlight}>
                                <b>전체 흐름:</b>&nbsp;
                                <FlowNode label="부과" status="PENDING" />
                                <span style={{ margin: '0 6px', color: '#94a3b8' }}>→ 매월 1일 →</span>
                                <FlowNode label="차감" status="PARTIAL" />
                                <span style={{ margin: '0 6px', color: '#94a3b8' }}>→ 매일 →</span>
                                <FlowNode label="완납" status="COMPLETED" />
                                <span style={{ margin: '0 8px', color: '#94a3b8' }}>또는</span>
                                <FlowNode label="이월" status="CARRIED_OVER" />
                            </div>
                        </div>

                        {/* 2. 자동 부과 */}
                        <div id="g-charge" style={gCardStyle}>
                            <div style={gTitleStyle}>2. 자동 부과 (매월 1일)</div>
                            <p style={gP}>매월 1일에 활성 단말기를 보유한 가맹점에 단말기비가 자동 부과됩니다.</p>
                            <ul style={gList}>
                                <li>부과 대상: 활성 상태인 단말기를 1대 이상 보유한 가맹점</li>
                                <li>부과 금액: <b>단말기 수 x 11,000원</b> = 당월 부과액</li>
                                <li>전월 미납분이 있으면 당월 부과액에 자동 합산</li>
                                <li>이미 부과된 가맹점에는 중복 부과되지 않음</li>
                            </ul>
                            <div style={gHighlight}>
                                <b>예시)</b> A가맹점 단말기 3대 활성 상태<br />
                                → 당월 부과: 3대 x 11,000원 = <b>33,000원</b><br />
                                → 전월 미납 5,000원 있으면: 33,000 + 5,000 = <b>총 38,000원</b>
                            </div>
                        </div>

                        {/* 3. 자동 차감 */}
                        <div id="g-deduct" style={gCardStyle}>
                            <div style={gTitleStyle}>3. 자동 차감 (매일)</div>
                            <p style={gP}>부과된 단말기비는 매일 자동으로 차감됩니다. 가맹점 유형에 따라 차감 방식이 다릅니다.</p>
                            <table style={gTable}>
                                <thead>
                                    <tr>
                                        <th style={gTh}>가맹점 유형</th>
                                        <th style={gTh}>차감 방식</th>
                                        <th style={gTh}>설명</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={gTd}><b>일반 가맹점</b> (은행 이체)</td>
                                        <td style={gTd}>정산금에서 차감</td>
                                        <td style={gTd}>당일 정산 이체 금액에서 차감<br />예: 정산금 50,000 - 단말기비 11,000 = 실이체 39,000원</td>
                                    </tr>
                                    <tr>
                                        <td style={gTd}><b>지갑 가맹점</b></td>
                                        <td style={gTd}>지갑 잔액에서 차감</td>
                                        <td style={gTd}>지갑 잔액에서 직접 출금. 정산 이체와 별개로 처리</td>
                                    </tr>
                                </tbody>
                            </table>
                            <p style={{ ...gP, fontWeight: 600, marginTop: '12px' }}>차감 결과에 따른 상태 변화:</p>
                            <table style={gTable}>
                                <thead>
                                    <tr>
                                        <th style={gTh}>차감 결과</th>
                                        <th style={gTh}>상태</th>
                                        <th style={gTh}>설명</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={gTd}>전액 차감 완료</td>
                                        <td style={gTd}><Badge status="COMPLETED" /></td>
                                        <td style={gTd}>남은 금액 0원. 해당 월 완납.</td>
                                    </tr>
                                    <tr>
                                        <td style={gTd}>일부만 차감</td>
                                        <td style={gTd}><Badge status="PARTIAL" /></td>
                                        <td style={gTd}>정산금 부족으로 일부만 차감. 다음 날 재시도.</td>
                                    </tr>
                                    <tr>
                                        <td style={gTd}>정산금 없음</td>
                                        <td style={gTd}><Badge status="PENDING" /></td>
                                        <td style={gTd}>당일 정산 건 없어 차감 불가. 다음 날 재시도.</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* 4. 이월 */}
                        <div id="g-carryover" style={gCardStyle}>
                            <div style={gTitleStyle}>4. 이월</div>
                            <p style={gP}>
                                월말까지 완납되지 않으면 미납 금액이 <b>다음 달로 이월</b>됩니다.
                                이월된 금액은 다음 달 부과 시 자동 합산됩니다.
                            </p>
                            <div style={gHighlight}>
                                <b>예시)</b><br />
                                3월 미납 11,000원 → 상태: <Badge status="CARRIED_OVER" /><br />
                                4월 부과: 2대 x 11,000 = 22,000원<br />
                                4월 총 청구: 22,000 + 이월 11,000 = <b>33,000원</b>
                            </div>
                            <div style={gWarning}>
                                <b>주의:</b> 이월은 매월 누적됩니다. 장기 미납 시 금액이 계속 쌓이므로, "직접 수금" 처리로 정리해 주세요.
                            </div>
                        </div>

                        {/* 5. 상태 설명 */}
                        <div id="g-status" style={gCardStyle}>
                            <div style={gTitleStyle}>5. 상태 설명</div>
                            <table style={gTable}>
                                <thead>
                                    <tr>
                                        <th style={gTh}>상태</th>
                                        <th style={gTh}>의미</th>
                                        <th style={gTh}>다음 단계</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={gTd}><Badge status="PENDING" /></td>
                                        <td style={gTd}>부과 완료, 차감 시작 전</td>
                                        <td style={gTd}>차감중, 이월, 수금완료, 취소</td>
                                    </tr>
                                    <tr>
                                        <td style={gTd}><Badge status="PARTIAL" /></td>
                                        <td style={gTd}>일부 금액 차감됨 (매일 추가 차감 시도)</td>
                                        <td style={gTd}>완료, 이월, 수금완료</td>
                                    </tr>
                                    <tr>
                                        <td style={gTd}><Badge status="COMPLETED" /></td>
                                        <td style={gTd}>전액 차감 완료 (완납)</td>
                                        <td style={gTd}>-</td>
                                    </tr>
                                    <tr>
                                        <td style={gTd}><Badge status="CARRIED_OVER" /></td>
                                        <td style={gTd}>미납 상태로 다음 달에 이월됨</td>
                                        <td style={gTd}>다음 달 부과에 합산</td>
                                    </tr>
                                    <tr>
                                        <td style={gTd}><Badge status="OFFLINE_COLLECTED" /></td>
                                        <td style={gTd}>현금/계좌이체 등으로 직접 수금 처리됨</td>
                                        <td style={gTd}>-</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* 6. 수동 부과 */}
                        <div id="g-manual" style={gCardStyle}>
                            <div style={gTitleStyle}>6. 수동 부과</div>
                            <p style={gP}>월중에 단말기가 추가되거나 신규 가맹점이 등록된 경우, 수동으로 부과할 수 있습니다.</p>
                            <ol style={{ ...gList, paddingLeft: '24px' }}>
                                <li>필터 영역의 <b>"수동부과"</b> 버튼 클릭</li>
                                <li><b>"미리보기"</b>에서 부과 대상 확인
                                    <ul style={{ paddingLeft: '16px', marginTop: '4px' }}>
                                        <li><b>NEW</b> — 해당 월에 아직 부과되지 않은 가맹점 (신규 등록 등)</li>
                                        <li><b>ADD</b> — 이미 부과된 가맹점이지만 이후 단말기 추가분</li>
                                    </ul>
                                </li>
                                <li>부과 대상 체크 후 <b>"부과 실행"</b> 클릭</li>
                            </ol>
                            <div style={gWarning}>
                                <b>주의:</b> "이월" 또는 "수금완료" 상태인 건에는 수동 부과가 적용되지 않습니다.
                            </div>
                        </div>

                        {/* 7. 부과 취소 */}
                        <div id="g-cancel" style={gCardStyle}>
                            <div style={gTitleStyle}>7. 부과 취소</div>
                            <p style={gP}>
                                잘못 부과된 건은 <Badge status="PENDING" /> 상태인 경우에만 취소할 수 있습니다.
                            </p>
                            <ul style={gList}>
                                <li>목록에서 해당 건 클릭 → 상세 모달 → <b>"부과 취소"</b> 버튼</li>
                                <li>취소 시 해당 부과 기록과 관련 차감 내역이 모두 삭제됩니다</li>
                            </ul>
                            <div style={gWarning}>
                                <b>차감이 한 번이라도 진행된 건</b>(차감중, 완료, 이월, 수금완료)은 취소할 수 없습니다.
                            </div>
                        </div>

                        {/* 8. 직접 수금 */}
                        <div id="g-offline" style={gCardStyle}>
                            <div style={gTitleStyle}>8. 직접 수금 (오프라인 수금)</div>
                            <p style={gP}>가맹점주가 현금, 계좌이체 등으로 단말기비를 직접 납부한 경우 사용합니다.</p>
                            <ul style={gList}>
                                <li>목록에서 해당 건 클릭 → 상세 모달 → <b>"수금 처리"</b> 버튼</li>
                                <li>남은 금액 전체가 수금 처리되며, 상태가 <Badge status="OFFLINE_COLLECTED" />로 변경</li>
                                <li>정산금 자동 차감에는 영향 없음 (단말기비 관리 내에서만 처리)</li>
                            </ul>
                            <div style={gHighlight}>
                                <b>활용:</b> 가맹점주가 "이번 달 단말기비를 계좌이체로 보냈다"고 연락 → 입금 확인 후 수금 처리
                            </div>
                        </div>

                        {/* 9. 이체 취소 시 복원 */}
                        <div id="g-restore" style={gCardStyle}>
                            <div style={gTitleStyle}>9. 이체 취소 시 자동 복원</div>
                            <p style={gP}>정산 이체가 취소(반려)된 경우, 해당 이체에서 차감했던 단말기비가 자동으로 복원됩니다.</p>
                            <ul style={gList}>
                                <li>복원된 금액만큼 미납 잔액이 다시 증가</li>
                                <li>상태가 이전 단계로 돌아가며, 다음 차감 시 다시 시도</li>
                            </ul>
                            <div style={gWarning}>
                                <b>예외:</b> 지갑에서 차감된 건은 복원되지 않습니다. 지갑 차감은 이체와 별개로 처리 완료된 것입니다.
                            </div>
                        </div>

                        {/* 10. 상태 흐름도 */}
                        <div id="g-flow" style={gCardStyle}>
                            <div style={gTitleStyle}>10. 상태 흐름도</div>
                            <div style={{
                                backgroundColor: '#f8fafc', borderRadius: '10px', padding: '24px',
                                border: '1px solid #e2e8f0', marginTop: '8px',
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap', gap: '6px' }}>
                                    <FlowNode label="부과 (대기)" status="PENDING" />
                                    <span style={{ color: '#94a3b8', fontSize: '16px' }}>→</span>
                                    <FlowNode label="차감중" status="PARTIAL" />
                                    <span style={{ color: '#94a3b8', fontSize: '16px' }}>→</span>
                                    <FlowNode label="완료" status="COMPLETED" />
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', gap: '40px', flexWrap: 'wrap' }}>
                                    <div style={{ textAlign: 'center' }}>
                                        <div style={{ fontSize: '11px', color: '#94a3b8', marginBottom: '4px' }}>대기/차감중에서 월말 도래</div>
                                        <div style={{ color: '#94a3b8', fontSize: '16px' }}>↓</div>
                                        <FlowNode label="이월" status="CARRIED_OVER" />
                                        <div style={{ fontSize: '11px', color: '#64748b', marginTop: '4px' }}>→ 다음 달 합산</div>
                                    </div>
                                    <div style={{ textAlign: 'center' }}>
                                        <div style={{ fontSize: '11px', color: '#94a3b8', marginBottom: '4px' }}>대기/차감중에서 직접 수금</div>
                                        <div style={{ color: '#94a3b8', fontSize: '16px' }}>↓</div>
                                        <FlowNode label="수금완료" status="OFFLINE_COLLECTED" />
                                    </div>
                                    <div style={{ textAlign: 'center' }}>
                                        <div style={{ fontSize: '11px', color: '#94a3b8', marginBottom: '4px' }}>대기 상태에서만 가능</div>
                                        <div style={{ color: '#94a3b8', fontSize: '16px' }}>↓</div>
                                        <span style={{
                                            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                            padding: '5px 14px', borderRadius: '6px', fontSize: '12px', fontWeight: 600,
                                            backgroundColor: '#fee2e2', color: '#991b1b', border: '1px solid #fca5a5',
                                        }}>취소 (삭제)</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* 11. FAQ */}
                        <div id="g-faq" style={gCardStyle}>
                            <div style={gTitleStyle}>11. 자주 묻는 질문 (FAQ)</div>

                            <div style={{ marginBottom: '16px' }}>
                                <p style={{ ...gP, fontWeight: 600, color: '#1e293b' }}>Q. 부과 후 단말기가 해지되면?</p>
                                <p style={gP}>이미 부과된 금액은 유지됩니다. 해지된 단말기는 다음 달 부과 시 대상에서 제외됩니다.</p>
                            </div>
                            <div style={{ marginBottom: '16px' }}>
                                <p style={{ ...gP, fontWeight: 600, color: '#1e293b' }}>Q. "차감중"인데 남은 금액을 바로 정리하고 싶어요.</p>
                                <p style={gP}>가맹점주로부터 직접 수금 후, 해당 건에서 <b>"수금 처리"</b>를 진행하면 됩니다.</p>
                            </div>
                            <div style={{ marginBottom: '16px' }}>
                                <p style={{ ...gP, fontWeight: 600, color: '#1e293b' }}>Q. 이월이 계속 쌓여서 금액이 너무 커졌어요.</p>
                                <p style={gP}>가맹점주와 협의하여 일시불 납부를 받고 <b>"수금 처리"</b>로 정리하는 것을 권장합니다.</p>
                            </div>
                            <div style={{ marginBottom: '16px' }}>
                                <p style={{ ...gP, fontWeight: 600, color: '#1e293b' }}>Q. 수동 부과 시 "NEW"와 "ADD"는 무엇인가요?</p>
                                <p style={gP}>
                                    <b>NEW</b>는 해당 월에 부과 기록이 없는 가맹점(신규 등), <b>ADD</b>는 이미 부과되었지만 이후 단말기가 추가된 가맹점입니다.
                                    ADD는 추가된 단말기 수만큼만 추가 부과됩니다.
                                </p>
                            </div>
                            <div style={{ marginBottom: '8px' }}>
                                <p style={{ ...gP, fontWeight: 600, color: '#1e293b' }}>Q. 정산금이 계속 없으면 단말기비는 어떻게 되나요?</p>
                                <p style={gP}>매일 차감을 시도하지만, 정산금이 없으면 차감 안 됩니다. 월말에 미납 금액이 다음 달로 이월됩니다.</p>
                            </div>
                        </div>

                        <div style={{ height: '20px' }} />
                    </div>
                </div>
            </div>
        </div>
    );
}

// 모달 오버레이 컴포넌트
function ModalOverlay({ children, onClose }) {
    return (
        <div
            style={{
                position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999,
                display: "flex", alignItems: "center", justifyContent: "center",
            }}
            onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
        >
            <div style={{
                backgroundColor: "#fff", borderRadius: "8px", padding: "20px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
            }}>
                {children}
            </div>
        </div>
    );
}

// 요약 인라인 항목
function SummaryItem({ label, value, color }) {
    return (
        <span>
            <span style={{ color: "#6b7280" }}>{label} </span>
            <strong style={{ color: color || "#1f2937" }}>{value}</strong>
        </span>
    );
}

// 정보 행
function InfoRow({ label, value, bold, color, span2 }) {
    return (
        <div style={{ gridColumn: span2 ? "1 / -1" : undefined }}>
            <span style={{ color: "#6b7280", fontSize: "12px" }}>{label}</span>
            <div style={{ fontWeight: bold ? "700" : "500", color: color || "#1f2937", fontSize: "13px" }}>{value}</div>
        </div>
    );
}

// 폼 필드
function FormField({ label, children }) {
    return (
        <div>
            <label style={{ fontSize: "12px", color: "#374151", marginBottom: "4px", display: "block", fontWeight: "600" }}>{label}</label>
            {children}
        </div>
    );
}

// 스타일
const thStyle = { padding: "8px 10px", textAlign: "center", fontSize: "12px", fontWeight: "600", whiteSpace: "nowrap" };
const tdStyle = { padding: "6px 10px", textAlign: "center", fontSize: "12px", whiteSpace: "nowrap" };
const closeBtnStyle = { background: "none", border: "none", cursor: "pointer", padding: "4px", display: "flex" };

export default MerchantTerminalFee;